// extracted by mini-css-extract-plugin
export var copyIcon = "_rc-2";
export var discountCard = "_rc-0";
export var discountCode = "_rc-3";
export var discountContent = "_rc-1";
export var loadingCard = "_rc-4";